/**
 * Created by DSadler on 02/05/2017.
 */

/*let emailItem = {
  emailId: "",
  emailName: "",
  emailCategory: "",
  emailLastEdited: "",
  emailContent: "",
};*/

//Created from an email template definition
export const CREATE_EMAIL = "CREATE_EMAIL";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
export const DELETE_EMAIL = "DELETE_EMAIL";
export const SET_EMAILS = "SET_EMAILS";

// need to know which i'm using, so pass Id on creation
export function createEmail(emailId, emailName, emailCategory, templateItem) {
  return {
    type: CREATE_EMAIL,
    emailId,
    emailName,
    emailCategory,
    templateItem,
  }
}
// need to know which i'm using, so pass Id on creation
export function updateEmail(emailId, emailItem) {
  return {
    type: UPDATE_EMAIL,
    emailId,
    emailItem,
  }
}
// need to know which i'm using, so pass Id on creation
export function deleteEmail(emailId) {
  return {
    type: DELETE_EMAIL,
    emailId,
  }
}

export function setEmails(emails) {
  return {
    type: SET_EMAILS,
    emails,
  }
}


// WEBPACK FOOTER //
// ./src/App/state/emails/actions.js